import type { FaireProductEntity } from "../../entity_types/product";

export const caden_lane_15: FaireProductEntity = {
  token: "caden-lane-15",
  type: "product",
  name: "Organic Cotton Gauze Swaddle Blanket | Vanilla",
  brandName: "Caden Lane",
  imageUrl:
    "https://cdn.faire.com/fastly/8bd839315db9db4122f3489e634e4c95253d84fd461e5f06bf03bea3122bfd7f.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_home-decor-bedding"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
